import AnnouncementCard from './announcementCard'
export default AnnouncementCard